<template>
  <div>
    <header class="fd-header">
      <!-- <div>
      </div> -->
      <div class="fd-header-left">
        <div class="fd-logo d-flex align-items-center" style="margin-right: 36px;" :style="isIntroduce?{'paddingLeft':'24px'}:{}">
          <!-- color: #1E5FA9; -->
          <template v-if="isIntroduce">
            <img :src="fudanImg" alt="" width="64" height="64" style="margin-right: 16px;">
            <span style="font-weight: bold;font-size: 18px;" class="color-dark">Zhipan Liu Research Group @Fudan</span>
          </template>
          <template v-if="!isIntroduce">
            <img src="../../static/lasphub.png" alt="" width="100" height="100" style="margin-right: 16px;">
            <span style="font-weight: bold;font-size: 18px;" class="color-dark">LASP Software Platform</span>
          </template>
        </div>
        <div class="fd-header-tags">
          <div v-for="(item,index) in tabs" :key="index" class="fd-header-tag"
               :class="{'fd-header-tag-active':item.active}" @click="chooseTab(index)">
            <i class="iconfont" :class="item.icon"></i>{{ item.name }}
          </div>
          <!-- // <div>
          //     LASP Software
          // </div> -->
        </div>
      </div>

      <div style="font-size:18px;" class="d-flex align-items-center">
        <div v-if="isIntroduce" style="padding-right: 340px">
          <Tooltip  always placement="right" :max-width="320" :delay="1500">
            <Icon type="md-chatbubbles" size="30" color="#445263" class="point"/>
            <div slot="content">
              <div class="mb-sm">联系方式：021-31242400</div>
              <div class="mb-sm"><i>Email: zpliu@fudan.edu.cn</i></div>
              <div><i>上海市杨浦区淞沪路2205号江湾化学楼A3011</i></div>
            </div>
          </Tooltip>
        </div>

        <template v-if="!isIntroduce">
          <span class="mr-md font-weight-bold" v-if="token">{{ $store.state.userInfo.uid || '' }}</span>
          <Icon type="md-contacts" style="font-size:28px;margin-right: 16px;"/>
          <a class="color-primary" style="margin-right: 16px;font-weight:bold" v-if="!token" @click="login()">Login/Register</a>
          <a class="color-primary" style="font-weight:bold" v-if="token" @click="logout()">Logout</a>
        </template>
      </div>
    </header>

  </div>

</template>

<script>
import {mapState} from 'vuex'
import {getToken} from "@/utils/token";

/**
  * @name  (组件名称)
  * @module 组件存放位置
  * @desc 组件描述
  * @author Jacke
  * @date
  * @param {Object} [title]    - 参数说明
  * @param {String} [columns] - 参数说明
  * @example 调用示例
  *  <></>
  */
export default {
  name: 'KetiHeader',
  components: {},
  props: {},
  data() {
    return {
      fudanImg:require('@/assets/img/fudan.png'),
      tabs: [
        {
        name: 'Liu group',
        url: '/introduce',
        active: false,
        icon: 'icon-introduce'
      },
      {
        name: 'LASP Software',
        url: '/lasp',
        active: true,
        icon: 'icon-lasp'
      }
      ],
      isIntroduce:false,
      token:null
    }
  },
  created() {
  },
  mounted() {
    this.token = getToken()
    this.updateTabIndex(this.$route)
  },
  watch: {
    '$route': 'updateTabIndex'
  },
  methods: {
    chooseTab(index) {
      console.log(index)
      if (this.tabs[index].active) return;
      this.tabs.forEach((e,i) => {
        e.active = i === index
      })
      this.$router.push({path: this.tabs[index].url})
    },
    updateTabIndex(to) {
      if (to.path.startsWith('/introduce')) {
        this.tabs[0].active = true
        this.tabs[1].active = false
        this.isIntroduce = true
      } else if (to.path.startsWith('/lasp')) {
        this.tabs[0].active = true
        this.tabs[0].active = false
        this.isIntroduce = false
      }
    },
    async logout() {
      await this.$store.dispatch('logout')
      // this.$router.push(`/passport/login?redirect=${this.$route.fullPath}`)
      // this.$router.push({name:'Login'})
    },
    async login() {
      // this.$router.push(`/passport/login?redirect=${this.$route.fullPath}`)
      await this.$store.dispatch('logout')
    }
  },
  computed: {
    // ...mapState({
    //   token: state => state.token
    // })
  },
}
</script>

<style lang="less" scoped>
.fd-header-left {
  display: flex;
  align-items: center;
}

.fd-header {
  width: 100%;
  height: 100px;
  line-height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-top: 16px;
  // margin-bottom: 32px;
}

.fd-header-tags {
  display: flex;
  align-items: center;
  // margin-bottom: 16px;
  // margin: 24px 0;
  .fd-header-tag {
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    padding: 0 17px;
    margin-right: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all .3s ease-in-out;
    background: #fff;
    font-size: 16px;

    .iconfont {
      margin-right: 8px;
    }
  }

  .fd-header-tag-active {
    background: var(--DARK);
    border-radius: 17px 17px 0 17px;
    color: white;
  }
}
///deep/ .ivu-tooltip-rel{
//  width: 40px;
//  height: 40px;
//}
/deep/ .ivu-tooltip-inner-with-width{
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/layout/header.vue